/**
 * Renders a dropdown menu for mobile navigation
 * WARNING: Uses dummy data for competitions
 */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiChevronDown } from "react-icons/hi";
import ExternalIcon from "../core/ExternalLinkIcon";

const MobileDropdownMenu = ({
  title,
  links,
  closeMenu,
  overridebg,
}) => {

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    if (closeMenu) {
      closeMenu();
    }
  };

  return (
    // if overrridebg, dark-3 otherwiose dark4
    <div className={overridebg ? "bg-light-4 dark:bg-dark-4" : "bg-light-2 dark:bg-dark-1"}>
      <button
        onClick={toggleDropdown}
        className={`w-full flex justify-start items-center pl-2 xs:pl-[12px] py-[6px] h-[36px] text-sm text-left ${!overridebg ? "" : "font-light"}`}
      >
        <p className={`mr-1 font-smm leading-tight`}>
          {title}</p>
        <HiChevronDown /> {/*isOpen ? <HiChevronUp /> : <HiChevronDown />*/}
      </button>
      {isOpen && (
        <div className="flex flex-col bg-light-1 dark:bg-dark-4 py-0.5">

          {links.map((link, index) => (
            <Link
              key={index}
              to={link.to}
              className="py-[3px] pl-2 xs:pl-[10px] text-sm"
              target={link.external ? "_blank" : "_self"}
              onClick={handleLinkClick} // Close the menu on link click
            >
              <div className="flex flex-row items-start justify-start">
                <p className="text-smm mr-1 leading-tight">{link.label}</p>
                {link.external && <ExternalIcon />}
              </div>
            </Link>
          ))}

        </div>
      )}
    </div>
  );
};

export default MobileDropdownMenu;
